import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOptAlt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconOptAlt"><Path d="M3.75 19.25H6.22886C7.32152 19.25 8.32776 18.6559 8.8556 17.6992L15.1444 6.30077C15.6722 5.34407 16.6785 4.75 17.7711 4.75H20.25M15.75 19.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconOptAlt;
